import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  invoices: [],
  unVerifiedInvoices: {
    data: [],
    total: 0,
    is_more: false,
    last_page: 1,
    error: null,
    current_page: 1,
    per_page: PAGELENGTH,
  },
  verifiedInvoices: {
    data: [],
    total: 0,
    is_more: false,
    last_page: 1,
    error: null,
    current_page: 1,
    per_page: PAGELENGTH,

  },
  invoice: {},
  appointment: {},
  appointClients: [],
  appointClientsListPage: [],
  generatedInvoices: [],
  loader: false,
}

export const invoicesSlice = createSlice({
  name: 'invoices',
  initialState: initialState,
  reducers: {
    setUnVerifiedInvoices: (state, { payload }) => {
      state.unVerifiedInvoices.data = payload?.data;
      state.unVerifiedInvoices.total = payload?.total;
      state.unVerifiedInvoices.is_more = payload?.is_more;
      state.unVerifiedInvoices.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },

    setVerifiedInvoices: (state, { payload }) => {
      state.verifiedInvoices.data = payload?.data;
      state.verifiedInvoices.total = payload?.total;
      state.verifiedInvoices.is_more = payload?.is_more;
      state.verifiedInvoices.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    updateUnVerifiedInvoice: (state, { payload, meta },) => {
      const item = state.unVerifiedInvoices.data[meta?.index];
      if (meta?.index >= 0) {



        for (const key in payload) {
          if (Object.prototype.hasOwnProperty.call(payload, key)) {
            const element = payload[key];
            if (key == "requester_name") {
              state.unVerifiedInvoices.data[meta?.index].requester_name = element
              state.unVerifiedInvoices.data[meta?.index].requester = element

              state.unVerifiedInvoices.data[meta?.index].invoice = {
                ...state.unVerifiedInvoices.data[meta?.index]?.invoice,
                ...payload
              };
              state.invoice = {
                ...state.unVerifiedInvoices.data[meta?.index],
                ...payload
              }
              return
            }
            else if (key == "checkin_time" || key == "start_time") {
              state.unVerifiedInvoices.data[meta?.index].appointment_assign.checkin_time = element;
              state.unVerifiedInvoices.data[meta?.index].start_time = element

              state.unVerifiedInvoices.data[meta?.index].invoice = {
                ...state.unVerifiedInvoices.data[meta?.index]?.invoice,
                ...payload
              };
              state.invoice = {
                ...state.unVerifiedInvoices.data[meta?.index],
                ...payload
              }
              return
            }
            else if (key == "checkout_time" || key == "end_time") {
              state.unVerifiedInvoices.data[meta?.index].appointment_assign.checkout_time = element
              state.unVerifiedInvoices.data[meta?.index].end_time = element

              state.unVerifiedInvoices.data[meta?.index].invoice = {
                ...state.unVerifiedInvoices.data[meta?.index]?.invoice,
                ...payload
              };
              state.invoice = {
                ...state.unVerifiedInvoices.data[meta?.index],
                ...payload
              }
              return
            }


            else if (key == "rate") {
              state.unVerifiedInvoices.data[meta?.index].rate = element

              state.unVerifiedInvoices.data[meta?.index].invoice = {
                ...state.unVerifiedInvoices.data[meta?.index]?.invoice,
                ...payload
              };
              state.invoice = {
                ...state.unVerifiedInvoices.data[meta?.index],
                ...payload
              }
              return

            }


          }
        }

        state.unVerifiedInvoices.data[meta?.index].invoice = {
          ...state.unVerifiedInvoices.data[meta?.index]?.invoice,
          ...payload
        };
        state.invoice = {
          ...state.unVerifiedInvoices.data[meta?.index],
          ...payload
        }
      }
    },
    updateUnVerifiedInvoice2: (state, { payload, },) => {
      const index = state.unVerifiedInvoices.data?.findIndex(unVerifiedInvoices => unVerifiedInvoices?.id == payload?.data?.appointment_id)
      if (index !== -1) {

        state.unVerifiedInvoices.data[index] = {
          ...state.unVerifiedInvoices.data[index],
          invoice: {
            ...state.unVerifiedInvoices.data[index]?.invoice,
            total_hours: payload?.data?.total_hours,
            total_amount: payload?.data?.total_amount,

          }
        };
      }
      state.invoice = payload
    },
    updateVerifiedInvoice: (state, { payload }) => {
      state.verifiedInvoices.data = payload;
    },

    setApptClients: (state, { payload }) => {
      state.appointClients = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setApptClientsList:(state, { payload }) => {
      state.appointClientsListPage = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setGeneratedInvocies: (state, { payload }) => {
      state.generatedInvoices = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },


    removeVerifiedInvoice: (state, { payload }) => {
      const index = state.verifiedInvoices.data.findIndex((item) => item.id === payload);
      if (index >= 0) {
        state.verifiedInvoices.data.splice(index, 1);
      }
    },

    removeUnVerifiedInvoice: (state, { payload }) => {
      const index = state.UnverifiedInvoices.data.findIndex((item) => item.id === payload);
      if (index >= 0) {
        state.unVerifiedInvoices.data.splice(index, 1);
      }
    },
    clearAllInvoices: (state, { payload }) => {
      state.unVerifiedInvoices = {};
      state.verifiedInvoices = {};


    },
    setVerifiedError: (state, { payload }) => {
      state.verifiedInvoices.error = payload
    },
    setUnverifiedError: (state, { payload }) => {
      state.unVerifiedInvoices.error = payload
    },
    setVerifiedLoader: (state, { payload }) => {
      state.verifiedInvoices.loader = payload
    },
    setUnverifiedLoader: (state, { payload }) => {
      state.unVerifiedInvoices.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

export const makeInvoice = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.makeInvoice(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // callback(true, json.data.message)
      callback(true, json.data.message, json.data.pdf, json.data.invoice)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}
export const makeMultipleInvoice = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  try {

    const json = await Api.makeMultipleInvoice(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // callback(true, json.data.message)
      callback(true, json.data.message, json.data.pdf, json.data.invoice)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
  }
}

export const sendInvoiceEmail = (invoiceId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setLoader(true))
  try {
    const json = await Api.sendInvoiceEmail({invoice_id: invoiceId})
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message)
    } else {
      callback(false, json.data.message)
    }
  } catch (error) {
    callback(false, 'Error sending email')
  }
  dispatch(setLoader(false))
}


export const fetchAppointClients = (page, params, disableLoader) => async (dispatch) => {
  const apiService = new Api();
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchAppointClients(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setApptClients(result.data.data));
      } else {
        dispatch(setApptClients(result.data.data));
      }
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader && dispatch(setLoader(false))
}
export const fetchAppointClientsListPage = (page, params, disableLoader) => async (dispatch) => {
  const apiService = new Api();
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchAppointClientsListPage(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setApptClientsList(result.data.data));
      } else {
        dispatch(setApptClientsList(result.data.data));
      }
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader && dispatch(setLoader(false))
}


export const fetchGeneratedInvoices = (page, params, disableLoader) => async (dispatch) => {
  const apiService = new Api();
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchGeneratedInvoices(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setGeneratedInvocies(result.data.data));
      } else {
        dispatch(setGeneratedInvocies(result.data.data));
      }
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader && dispatch(setLoader(false))
}
export const updateInvoice = (data, itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setUnverifiedLoader({}))
  dispatch(setUnverifiedLoader(true))
  try {
    data = {
      start_time: data?.start_time ?? data?.appointment_assign?.checkin_time,
      end_time: data?.end_time ?? data?.appointment_assign?.checkout_time,
      rate: data?.rate ?? data.invoice?.rate,
      patient_last_name: data?.patient_last_name ?? data?.invoice?.patient_last_name,
      patient_first_name: data?.patient_first_name ?? data?.invoice?.patient_first_name,
      requester: data?.requester ?? data?.requester_name ?? data?.requester_name,
      notes: data?.notes ?? data?.invoice?.notes
    }

    const json = await Api.updateInvoice(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      dispatch(updateUnVerifiedInvoice2(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setUnverifiedLoader(json.data))
    }
    dispatch(setUnverifiedLoader(false))
  } catch (error) {
    console.log(error)
    dispatch(setUnverifiedLoader(false))
    // callback(false)

  }
}

export const verifyInvoice = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setUnverifiedError({}))
  dispatch(setUnverifiedLoader(true))
  try {

    const json = await Api.verifyInvoice(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setInvoice(json.data))
      callback(true, json.data.message)
      dispatch(setUnverifiedLoader(false))
    } else if (json.status == 422) {
      dispatch(setUnverifiedError(json.data))
      callback(false, json.data.message)
      dispatch(setUnverifiedLoader(false))
    }
  } catch (error) {
    console.log(error)
    dispatch(setUnverifiedLoader(false))
    // callback(false)

  }
}

export const fetchUnVerifiedInvoices = (page, params, disableLoader) => async (dispatch) => {
  const apiService = new Api();
  !disableLoader && dispatch(setUnverifiedLoader(true))
  try {
    const result = await Api.fetchUnVerifiedInvoices(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setUnVerifiedInvoices(result.data.data));
      } else {
        dispatch(setUnVerifiedInvoices(result.data.data));
      }

      !disableLoader && dispatch(setUnverifiedLoader(false))
    }
    else if (result?.status == 422) {
      dispatch(setUnverifiedError(result.data))
      !disableLoader && dispatch(setUnverifiedLoader(false))
    }
  } catch (error) {
    console.log("error", error)

    !disableLoader && dispatch(setUnverifiedLoader(false))

  }
}

export const fetchVerifiedInvoices = (page, params, disableLoader) => async (dispatch) => {
  const apiService = new Api();
  !disableLoader && dispatch(setVerifiedLoader(true))
  try {

    const result = await Api.fetchVerifiedInvoices(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setVerifiedInvoices(result.data.data));
      } else {
        dispatch(setVerifiedInvoices(result.data.data));
      }
      !disableLoader && dispatch(setVerifiedLoader(false))
    }
    else if (result?.status == 422) {
      dispatch(setVerifiedError(result.data))
      !disableLoader && dispatch(setVerifiedLoader(false))
    }
  } catch (error) {
    console.log("error", error)
    !disableLoader && dispatch(setVerifiedLoader(false))

  }
}

export const removeInvoices = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    const json = await Api.removeInvoices(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}
export const removeMultipleInvoices = (ids, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    const json = await Api.removeMultipleInvoices(ids)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}
export const changeStatus = (id, callback, data) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.statusChange(id,data , 'invoices')
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}

export const {
  setUnVerifiedInvoices,
  clearAllInvoice,
  setMoreInvoices,
  setVerifiedInvoices,
  removeVerifiedInvoice,
  removeUnverifiedInvoice,
  setApptClientsList,
  setVerifiedError,
  setUnverifiedError,
  setVerifiedLoader,
  setUnverifiedLoader,
  updateUnVerifiedInvoice,
  updateVerifiedInvoice,
  updateUnVerifiedInvoice2,
  setApptClients,
  setGeneratedInvocies,
  setLoader,
  setError,
} = invoicesSlice.actions


export default invoicesSlice.reducer
export const invoicesSelector = state => state.invoices


